<template>
  <div id="footer" class="container-fluid">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-4">
        <div class="logo">
          <img src="@/assets/img/logo_black.png" alt="logo图" />
        </div>
        <!-- <p class="text-left" style="color: #fff; font-weight: bolder">
          联系我们
        </p> -->
        <p class="text-left quickShow" style="color: #fff">QQ技术交流群：878807527</p>
        <p class="text-left quickShow" style="color: #fff">QQ群2：640216986</p>
        <p class="text-left quickShow" style="color: #fff">
          联系邮箱：lovepyang@sina.com
        </p>
        <p class="text-left quickShow" style="color: #fff">
          <span class="glyphicon glyphicon-user"></span> 微信在线客服：
          <a href="https://work.weixin.qq.com/kfid/kfc7f9fe8e2b464d24f" target="_blank" style="color:#0ce9f1;">点击联系客服</a>
        </p>
        <p class="text-left quickShow" style="color: #fff">
          公司地址：广东省东莞市东城街道东科路1号6栋206室
        </p>
        <p class="text-left quickShow" style="color: #fff">
          Copyright 2025 东莞市奇智科技有限公司
          <a href="http://beian.miit.gov.cn" target="blank"
            >粤ICP备2022014198号
          </a>
          &nbsp;
        </p>
      </div>
      <div class="col-md-4">
        <p class="text-center quickP" style="color: #fff; font-weight: bolder">
          快捷导航
        </p>
        <p class="text-center quickP">
          <a
            class="quickShow"
            href="https://www.qizhin.com/webH5/#/pages/login/login"
            target="_blank"
            >工地考勤记工网页版</a
          >
        </p>
        <p class="text-center quickP">
          <a class="quickShow" href="https://www.qizhin.com/stong" target="_blank">施工日志网页</a>
        </p>
        <p class="text-center quickP">
          <a class="quickShow" href="https://www.qizhin.com/help.html" target="_blank">奇智考勤软件使用帮助</a>
        </p>
        <p class="text-center quickP">
          <a class="quickShow" href="https://www.qizhin.com/rizhiHelp.html" target="_blank">施工日志使用说明</a>
        </p>
        <p class="text-center quickP">
          <a
            class="quickShow"
            href="https://www.qizhin.com/dist/#/login"
            target="_blank"
            >奇智考勤运营平台</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  color: #ccc;
  background: linear-gradient(180deg, #1a1a2e 0%, #0f0f1a 100%);
  overflow: hidden;
  text-align: center;
  padding: 40px 0 30px;
  font-size: 13px;
  line-height: 2;
}
#footer .row {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
}
.logo {
  margin-bottom: 20px;
}
.logo img {
  height: 45px;
  width: auto;
  filter: brightness(0) invert(1);
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.quickShow {
  color: #bbb;
  text-decoration: none;
  transition: color 0.3s ease;
}
.quickShow:hover {
  color: #fff;
}
.quickP {
  margin-bottom: 6px;
}
.quickP a {
  color: #bbb;
  text-decoration: none;
  transition: color 0.3s ease;
}
.quickP a:hover {
  color: #fff;
  text-decoration: underline;
}
#footer a {
  color: #999;
  transition: color 0.3s ease;
}
#footer a:hover {
  color: #fff;
  text-decoration: underline;
}
@media screen and (max-width: 997px) {
  #footer {
    padding: 30px 15px 20px;
    font-size: 12px;
  }
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue